import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["path"]

  connect() {
    this.lastStart = null
    this.lastEnd = null
    this.draw()
  }

  disconnect() {
    cancelAnimationFrame(this.drawFrame)
    cancelAnimationFrame(this.syncFrame)
    this.drawFrame = null
    this.syncFrame = null
  }

  resize() {
    if (this.drawFrame) return
    this.drawFrame = requestAnimationFrame(() => { this.drawFrame = null; this.draw() })
  }

  scroll() {
    if (this.syncFrame) return
    this.syncFrame = requestAnimationFrame(() => { this.syncFrame = null; this.sync() })
  }

  draw() {
    this.items = Array.from(this.element.querySelectorAll("li")).map(listItem => {
      const anchor = listItem.querySelector("a")
      const target = anchor && document.getElementById(anchor.getAttribute("href").slice(1))
      return { listItem, anchor, target }
    }).filter(item => item.target)

    const path = []
    let indent
    this.items.forEach((item, index) => {
      const x = item.anchor.offsetLeft - 5
      const y = item.anchor.offsetTop
      const height = item.anchor.offsetHeight
      if (index === 0) {
        path.push("M", x, y, "L", x, y + height)
        item.pathStart = 0
      } else {
        if (indent !== x) path.push("L", indent, y)
        path.push("L", x, y)
        this.pathTarget.setAttribute("d", path.join(" "))
        item.pathStart = this.pathTarget.getTotalLength() || 0
        path.push("L", x, y + height)
      }
      indent = x
      this.pathTarget.setAttribute("d", path.join(" "))
      item.pathEnd = this.pathTarget.getTotalLength()
    })
    this.pathLength = this.pathTarget.getTotalLength()
    this.lastStart = null
    this.lastEnd = null
    this.sync()
  }

  sync() {
    let start = this.pathLength
    let end = 0
    this.items.forEach(item => {
      const bounds = item.target.getBoundingClientRect()
      const visible = bounds.bottom > window.innerHeight * 0.1 && bounds.top < window.innerHeight * 0.8
      item.listItem.classList.toggle("visible", visible)
      if (visible) {
        start = Math.min(item.pathStart, start)
        end = Math.max(item.pathEnd, end)
      }
    })
    if (start < end) {
      if (start !== this.lastStart || end !== this.lastEnd) {
        this.pathTarget.setAttribute("stroke-dashoffset", "1")
        this.pathTarget.setAttribute("stroke-dasharray", `1, ${start}, ${end - start}, ${this.pathLength}`)
      }
      this.pathTarget.setAttribute("opacity", 1)
    } else {
      this.pathTarget.setAttribute("opacity", 0)
    }
    this.lastStart = start
    this.lastEnd = end
  }
}
